export default {
  advertisement: {
    publishPage: {},
  },
  projectAdvertisement: {
    publishPage: {},
  },
};
